/**
* @ComponentFor Avensia.Shop.Features.Shared.Partials.PropertyTypes.ContentArea
*/
import React from 'react';
import classnames from 'classnames';
import editorAttributesFor from 'Shared/editor-attributes-for';
import * as styles from './content-area.scss';
import { resolveSyncIfLoadedOrThrow } from '@avensia/nitro5-scope';
export function contentAreaItems(propertyName, items) {
    return (items || [])
        .filter(i => !!i)
        .map((item, i) => {
        const Component = resolveSyncIfLoadedOrThrow(item.componentName);
        const itemOpts = window.IS_IN_EDIT_MODE && propertyName
            ? {
                'data-epi-block-id': item.$idForOnPageEditing,
                'data-epi-block-info': '{&quot;missingrenderer&quot;:false}',
            }
            : {};
        return (React.createElement("div", Object.assign({ key: i }, itemOpts),
            React.createElement(Component, Object.assign({}, item))));
    });
}
const ContentArea = (props) => {
    return React.createElement(props.tagName || 'div', editorAttributesFor(props.propertyName, classnames(props.className, styles.base)), contentAreaItems(props.propertyName, props.items));
};
ContentArea.supportsPropertyForIntegration = true;
export default ContentArea;
